import { query } from '@trlogic/client-js';
import HttpClient from 'gateway/HttpClient';
import { notBlank, notUndefined } from 'util/Assert';
import AiModelClient from './AiModelClient';
import HttpMethod from '../../constant/HttpMethod';
import { AiModelMethods } from '../../constant/MethodNames';
import { ActionType } from '../../constant/Constants';
import SelectQuery = query.SelectQuery;
import { MLOpsModel } from '../../domain/mlops/MLOpsDomains';

class NestAiModelClient implements AiModelClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(item: MLOpsModel, trainingFile: File | null, validationFile: File | null): Promise<void> {
    notUndefined(item, 'Ai model cannot be undefined');
    const dto = { id: item.name, aiModel: item };
    const formData = new FormData();
    formData.append('dto', JSON.stringify(dto));
    formData.append('trainingFile', trainingFile ?? '');
    formData.append('validationFile', validationFile ?? '');
    return this.httpClient.execute(HttpMethod.POST, AiModelMethods.SAVE, formData);
  }

  public async remove(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${AiModelMethods.REMOVE}/${id}`);
  }

  public deploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${AiModelMethods.DEPLOY}/${id}`);
  }

  public undeploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${AiModelMethods.UNDEPLOY}/${id}`);
  }

  public exist(id: string): Promise<boolean> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${AiModelMethods.EXIST}/${id}`);
  }

  public count(query: SelectQuery): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.GET, AiModelMethods.COUNT, undefined, { query });
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, AiModelMethods.BULK_ACTION, payload);
  }
}

export default NestAiModelClient;
